import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';
import dayjs from 'dayjs';

//Servicios
import { DJCPService } from '../../services/api';

//Componentes
import { toast } from 'react-toastify';
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import DJCPList from './DJCPList';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';
import post_stamp from '../../assets/imgs/post-stamp.png';

function DJCPListContainer() {
    const { token, settings, user, masters, viniedos } = useGlobalContext();
    const { register, handleSubmit, watch, setError, formState } = useForm({
        defaultValues: { myViniedo: 0 },
    });
    const Navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [OpenPagoModal, setOpenPagoModal] = useState(false);
    const [SelectedDJCP, setSelectedDJCP] = useState(0);
    const [TimbrePago, setTimbrePago] = useState(false);
    const [DJCPListData, setDJCPListData] = useState([]);

    const EnableBtn = parseInt(watch('myViniedo'));

    const TimbreModalContent = (
        <section>
            <main style={{ marginBottom: '1rem', textAlign: 'justify' }}>
                <b>ATENCIÓN:</b> Verifique que la cantidad de kilos ingresados
                para cada variedad de uva: Una vez timbrada la DJCP, ya no se
                podrá cambiar.
                <br />
                Usted será redireccionado a la pasarela de pagos para abonar el
                Timbre de la declaración. Por favor confirme el procedimiento
            </main>
            <footer>
                <button
                    className="btn btn-primary"
                    onClick={() => payDJCP(SelectedDJCP.id)}
                >
                    Aceptar
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={() => setOpenPagoModal(false)}
                >
                    Cancelar
                </button>
            </footer>
        </section>
    );

    useEffect(() => {
        const getMyDJCP = async () => {
            try {
                setLoader(true);

                const myDJCPs = await DJCPService.all({
                    token,
                    usuarioId: user.id,
                    // serie: parseInt(dayjs(new Date()).format('YYYY')),
                });

                if (myDJCPs) {
                    setDJCPListData(myDJCPs.data);
                    setTableData(buildTableData(myDJCPs.data));
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
            }
        };

        if (user.tipo !== 3) getMyDJCP();
    }, [TimbrePago]);

    /**Funcion que crea el objeto para pasarle al componente tabla y listar las DJCPs*/
    const buildTableData = (
        data = [
            {
                id: 1,
                viniedo: '',
                fecha: '',
                fecha_cierre: '',
                timbre: '',
                habilitada: '',
                total_kilos: '',
                cerrada: '',
            },
        ]
    ) => {
        return {
            title: 'Declaraciones de Cosecha Probable',
            headers: [
                'ID',
                'Viñedo',
                'Fecha',
                'Timbre',
                'Habilitada',
                'Kilos Totales',
                'Cerrada',
                ' ',
            ],
            pagination: 10,
            data: data?.map((dj) => {
                return {
                    id: `${dj.serie}-P-${dj.numero}`,
                    viniedo: dj.viniedo,
                    fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                    timbre: dj.timbre ? 'PAGO' : 'NO PAGO',
                    habilitada: masters.HabilitationTypes?.find(
                        (ht) => ht.id === dj.habilitada
                    )?.nombre.replace('_', ' '),
                    kilosTotales: dj.total_Kilos,
                    cerrada: !dj.fecha_Cierre
                        ? 'NO'
                        : dayjs(dj.fecha_cierre).format('DD-MM-YYYY'),
                    icons: (
                        <div>
                            <Link
                                to={
                                    RoutesApp.Declaraciones.cosechaProbable +
                                    dj.id
                                }
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={right_arrow}
                                    title="Visualizar"
                                    alt="Visualizar"
                                />
                            </Link>
                            {!dj.fecha_Cierre &&
                                !dj.timbre &&
                                dj.habilitada != 1 && (
                                    <Link
                                        to={
                                            RoutesApp.Declaraciones
                                                .nuevaCosechaProbable + dj.id
                                        }
                                        className="table-icon_container"
                                    >
                                        <img
                                            className="table-icon"
                                            src={pencil}
                                            title="Editar"
                                            alt="Editar"
                                        />
                                    </Link>
                                )}
                            {!dj.timbre && dj.habilitada != 1 && (
                                <Link to="#" className="table-icon_container">
                                    <img
                                        className="table-icon"
                                        src={post_stamp}
                                        title="Pagar Timbre"
                                        alt="Pagar Timbre"
                                        onClick={() => {
                                            setOpenPagoModal(true);
                                            setSelectedDJCP(dj);
                                        }}
                                    />
                                </Link>
                            )}
                        </div>
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    const newDJCP = async (data) => {
        try {
            setLoader(true);

            const newDJCP = await DJCPService.create({
                token,
                viniedoId: data.myViniedo,
            });
            if (newDJCP) {
                Navigate(
                    RoutesApp.Declaraciones.nuevaCosechaProbable +
                        newDJCP.data.cabecera.id
                );
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    async function payDJCP(id) {
        try {
            setLoader(true);

            const PaidDJCP = await DJCPService.payTimbre({
                token,
                id,
            });

            if (PaidDJCP) {
                setOpenPagoModal(false);
                setTimbrePago(!TimbrePago);
                toast('DJCP pagada con éxito', { type: 'success' });
            }

            setLoader(false);
        } catch (err) {
            toast('Pago de DJCP fallido', { type: 'error' });
            setLoader(false);
            return err;
        }
    }

    return loader ? (
        <Spinner />
    ) : (
        <>
            <Modal
                title={'Pago de Timbre'}
                questionModal
                isOpen={OpenPagoModal}
                onClose={() => setOpenPagoModal(false)}
            >
                {TimbreModalContent}
            </Modal>
            <DJCPList
                functions={{
                    register,
                    handleSubmit,
                    watch,
                    setError,
                    formState,
                    newDJCP,
                }}
                states={{
                    DJCPListData,
                    tableData,
                    viniedos,
                    settings,
                    EnableBtn,
                }}
            />
        </>
    );
}

export default DJCPListContainer;
